import { isPcPlatform } from '@office-start/device-detection-utility';
import EdgeworthIcon from '@office-start/edgeworth-icon';
import React from 'react';
export var LocationFilterKey;
(function (LocationFilterKey) {
    LocationFilterKey["cloudFiles"] = "Cloud files Filter";
    LocationFilterKey["local"] = "Local Filter";
    LocationFilterKey["attachments"] = "Attachments Filter";
})(LocationFilterKey || (LocationFilterKey = {}));
var filterLocalKey = function (filterKey) {
    return filterKey !== LocationFilterKey.local || isPcPlatform();
};
var filterIconsArray = [
    [
        LocationFilterKey.cloudFiles,
        React.createElement(EdgeworthIcon, { key: LocationFilterKey.cloudFiles, iconName: "CloudIcon" }),
    ],
    [
        LocationFilterKey.local,
        React.createElement(EdgeworthIcon, { key: LocationFilterKey.local, iconName: "DesktopIcon" }),
    ],
    [
        LocationFilterKey.attachments,
        React.createElement(EdgeworthIcon, { key: LocationFilterKey.attachments, iconName: "AttachIcon" }),
    ],
].filter(function (val) { return filterLocalKey(val[0]); });
export var LocationFilterToIconMap = new Map(filterIconsArray);
var filterFunctionsArray = [
    [
        LocationFilterKey.cloudFiles,
        function (doc) {
            return doc.isOneDriveForBusinessFile || doc.isSharePointFile;
        },
    ],
    [LocationFilterKey.local, function (doc) { return doc.isLocalFile; }],
    [
        LocationFilterKey.attachments,
        function (doc) { return doc.isEmailAttachment; },
    ],
].filter(function (val) { return filterLocalKey(val[0]); });
export var LocationFiltersMap = new Map(filterFunctionsArray);
//# sourceMappingURL=LocationFilters.js.map